import React, { useState } from "react";
import ConsultancyNavbar from "../ConsultancyNavbar";
import ConsultancyFooter from "../ConsultancyFooter";

const ContactPage = () => {
  const [formData, setFormData] = useState({
    agencyName: "",
    name: "",
    email: "",
    phone: "",
    country: "uk",
    message: "",
  });
  const [sent, setSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);
    setTimeout(() => {
      setSent(false);
      setFormData({ agencyName: "", name: "", email: "", phone: "", country: "uk", message: "" });
    }, 4000);
  };

  return (
    <div className="consultancy-wrapper">
      <ConsultancyNavbar />

      {/* Header */}
      <section className="py-5 consultancy-section-dark text-center">
        <div className="container">
          <span className="consultancy-badge-gold mb-2">Agency Support & Inquiries</span>
          <h1 className="display-5 font-weight-bold consultancy-gold-title mb-3">Partner With EdOps Global</h1>
          <p className="consultancy-lead-text mx-auto" style={{ maxWidth: "650px" }}>
            Ready to streamline your study abroad consultancy operations? Contact our enterprise partnership team.
          </p>
        </div>
      </section>

      {/* Main Grid */}
      <section className="py-5 container">
        <div className="row g-4">
          {/* Office Info Left */}
          <div className="col-lg-5">
            <div className="consultancy-glass-card p-4 p-md-5 h-100">
              <h3 className="consultancy-gold-title font-weight-bold mb-4">Enterprise Support Desk</h3>

              <ul className="list-unstyled d-flex flex-column gap-3 text-muted small mb-4">
                <li className="d-flex align-items-start gap-3">
                  <div className="avatar bg-soft-warning text-warning p-3 rounded-circle">
                    <i className="fas fa-building-user fa-lg"></i>
                  </div>
                  <div>
                    <strong className="text-white d-block fs-6">Global Technology Hub</strong>
                    <span>EdOps Tower, Level 5, Jubilee Hills, Hyderabad - 500033</span>
                  </div>
                </li>
                <li className="d-flex align-items-start gap-3">
                  <div className="avatar bg-soft-warning text-warning p-3 rounded-circle">
                    <i className="fas fa-phone-alt fa-lg"></i>
                  </div>
                  <div>
                    <strong className="text-white d-block fs-6">Agency Partnership Desk</strong>
                    <span>+91 1800-425-9988 / +91 98765 43210</span>
                  </div>
                </li>
                <li className="d-flex align-items-start gap-3">
                  <div className="avatar bg-soft-warning text-warning p-3 rounded-circle">
                    <i className="fas fa-envelope fa-lg"></i>
                  </div>
                  <div>
                    <strong className="text-white d-block fs-6">Enterprise Email</strong>
                    <span>partnerships@edopsglobal.com / support@edopsglobal.com</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          {/* Contact Form Right */}
          <div className="col-lg-7">
            <div className="consultancy-glass-card p-4 p-md-5">
              <h3 className="consultancy-gold-title font-weight-bold mb-1">Request Agency Demo & Pricing</h3>
              <p className="text-muted small mb-4">Fill out your agency details below and an enterprise software specialist will contact you.</p>

              {sent && (
                <div className="alert alert-success font-weight-bold mb-4">
                  <i className="fas fa-check-circle mr-2"></i> Demo inquiry received! An EdOps enterprise manager will contact your agency shortly.
                </div>
              )}

              <form onSubmit={handleSubmit} className="row g-3">
                <div className="col-md-6">
                  <label className="small text-muted font-weight-bold mb-1">Agency / Consultancy Name *</label>
                  <input
                    type="text"
                    className="form-control consultancy-form-control"
                    placeholder="Global Scholars Consultancy"
                    value={formData.agencyName}
                    onChange={(e) => setFormData({ ...formData, agencyName: e.target.value })}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="small text-muted font-weight-bold mb-1">Contact Person Name *</label>
                  <input
                    type="text"
                    className="form-control consultancy-form-control"
                    placeholder="John Doe (Director)"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="small text-muted font-weight-bold mb-1">Work Email Address *</label>
                  <input
                    type="email"
                    className="form-control consultancy-form-control"
                    placeholder="john@globalscholars.com"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="small text-muted font-weight-bold mb-1">Mobile / WhatsApp Number *</label>
                  <input
                    type="tel"
                    className="form-control consultancy-form-control"
                    placeholder="+91 98765 43210"
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    required
                  />
                </div>
                <div className="col-12">
                  <label className="small text-muted font-weight-bold mb-1">Tell Us About Your Agency & Software Requirements *</label>
                  <textarea
                    className="form-control consultancy-form-control"
                    rows="4"
                    placeholder="Mention your annual student volume, counsellor team size, and target countries..."
                    value={formData.message}
                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                    required
                  ></textarea>
                </div>
                <div className="col-12 mt-4">
                  <button type="submit" className="consultancy-btn-gold w-100 py-3 text-uppercase font-weight-bold">
                    <i className="fas fa-paper-plane mr-2"></i> Submit Agency Inquiry
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

      <ConsultancyFooter />
    </div>
  );
};

export default ContactPage;
